import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x-twitter",
  "use": "icon-x-twitter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-x-twitter\">\n<path d=\"M18.5372 3H21.7588L14.7223 11.0476L23 22H16.5202L11.4413 15.3591L5.6369 22H2.41069L9.93546 13.3906L2 3H8.64407L13.2301 9.06995L18.5372 3ZM17.4055 20.0726H19.1897L7.6721 4.82692H5.75554L17.4055 20.0726Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol